const KEY = "resguard:literature-draft:v1";
const MAX_LENGTH = 4000;

/** Tab-scoped, never a URL parameter. Reading does not consume StrictMode drafts. */
export function readLiteratureDraft(): string {
  try {
    const value = sessionStorage.getItem(KEY) || "";
    return value.length <= MAX_LENGTH ? value : "";
  } catch { return ""; }
}

export function saveLiteratureDraft(question: string): boolean {
  const value = question.trim();
  if (!value || value.length > MAX_LENGTH) return false;
  try { sessionStorage.setItem(KEY, value); return true; }
  catch { return false; }
}

export function clearLiteratureDraft(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* Storage can be unavailable. */ }
}
